module.exports = __webpack_public_path__ + "img/baseline-delete_forever-24px.04a05aec.svg";